import { Select } from "antd";
import React from "react";
import { estatusPt } from "../../constants/const";

export const EstatusPTDropdown = ({ value, onChange }) => {

  return (
    <Select
      size="small"
      style={{ width: "100%" }}
      value={value}
      onChange={onChange}
      options={estatusPt}
      placeholder="Estatus"
    />
  );
};
